import { render, staticRenderFns } from "./BasicInfoSetting.vue?vue&type=template&id=22f0afc8&scoped=true&"
import script from "./BasicInfoSetting.vue?vue&type=script&lang=js&"
export * from "./BasicInfoSetting.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfoSetting.vue?vue&type=style&index=0&id=22f0afc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f0afc8",
  null
  
)

export default component.exports